$(document).on("click", ".attraction-preview .fav-link", (e) => {
  FAVOURITES.toggle(
    $(e.currentTarget)
      .closest(".attraction-preview")
      .data("href")
      .split("/")
      .slice(-1)[0]
  );
  $("#favourites-refresh-button").removeClass("d-none");
});
